import './component.scss'
import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'chart.js'

const BAR_CHART_SELECTOR = '.js-articleAgeBarChart-target'

$(() => {
  const $barChartTarget = $(BAR_CHART_SELECTOR)
  if ($barChartTarget.length === 0) {
    return
  }

  const data = $barChartTarget.data('chart')
  const { labels, datasets } = data

  const maxValue = Math.max(...datasets[0].data)
  const margin = maxValue * 0.05
  const yAxesMax = maxValue + margin

  new Chart($barChartTarget, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: datasets
    },
    options: {
      responsive: true,
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: '#98a6b5',
            fontSize: 12
          }
        }],
        yAxes: [{
          gridLines: {
            drawBorder: false
          },
          ticks: {
            display: false,
            min: 0,
            max: yAxesMax,
            stepSize: yAxesMax / 2
          }
        }]
      },
      legend: {
        display: false
      },
      title: {
        display: false
      },
      animation: {
        duration: 0
      },
      tooltips: {
        enabled: false
      },
      hover: {
        mode: null
      }
    }
  })
})
